import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { FlexLayoutModule } from '@angular/flex-layout';
import { MatChipsModule } from '@angular/material/chips';

import { LimitToPipe } from './pipes/limit-to.pipe';
import { LocalDatePipe } from './pipes/local-date.pipe';
import { YesNoPipe } from './pipes/yes-no.pipe';
import { FromNowPipe } from './pipes/from-now.pipe';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { FirstLetterPipe } from './pipes/firstLetter.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { CountDown } from './pipes/countdown.pipe';
import { CountDownInSec } from './pipes/countdownInSec.pipe';
import {
  UpdateStatusDialogComponent,
  FetchEntityDialogComponent,
  DeleteEntityDialogComponent,
  ErrorEntityDialogComponent,
  AlertEntityDialogComponent,
  AlertActionEntityDialogComponent,
  ActionNotificationComponent,
  ConfirmSelectEntityDialogComponent,
  ModalPasswordDialogComponent,
  ConfirmInputEntityDialogComponent,
} from './components/modals';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingScreenComponent } from './components/loading-screen/loading-screen.component';
import { ConfirmFileEntityDialogComponent } from './components/modals/confirm-file-entity-dialog/confirm-file-entity-dialog.component';
import { EditProfileDialogComponent } from './components/modals/edit-profile-dialog/edit-profile-dialog.component';
import { MatRadioModule } from '@angular/material/radio';
import { MaterialModule } from './material.module';
import { LayoutComponent } from './layout/layout.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ConfirmDialogComponent } from './components/modals/confirm-dialog/confirm-dialog.component';
import { EnumPipe } from './pipes/enum.pipe';
import { ModalUploaderDialogComponent } from './components/modals/custom-uploader-dialog/custom-uploader-dialog.component';
import { AddGenericNoteDialogComponent } from './components/modals/add-generic-note-modal/add-generic-note-modal.component';
import { RiskLogsDialogComponent } from '../features/risks-strengths/risk-logs-modal/risk-logs-modal.component';
import { SafeHtmlPipe } from './pipes/safeHtml.pipe';
import { ModalViewDialogComponent } from './components/custom-view-dialog/custom-view-dialog.component';
import { EnumViewComponent } from './components/enum-view/enum-view.component';
import { CustomMetadataTableComponent } from './components/custom-metadata-table/custom-metadata-table.component';
import { CustomMultipleSelectTreeComponent } from './components/custom-multiple-select-tree/custom-multiple-select-tree.component';
import { CustomSelectDialogComponent } from './components/custom-select-dialog/custom-select-dialog.component';
import { CustomSelectComponent } from './components/custom-select/custom-select.component';
import { CustomSelectAutocompleteComponent } from './components/custom-select-autocomplete/custom-select-autocomplete.component';
import { ModalDialogComponent } from './components/custom-dialog/custom-dialog.component';
import { CustomMultipleSelectComponent } from './components/custom-multiple-select/custom-multiple-select.component';
import { CustomTagsComponent } from './components/custom-tags/custom-tags.component';
import { CustomDateTimeComponent } from './components/custom-datetime/custom-datetime.component';
import { RulesViewDialogComponent } from './components/rules-view-dialog/rules-view-dialog.component';
import { EvaluationViewDialogComponent } from './components/evaluation-view-dialog/evaluation-view-dialog.component';
import { CustomBasechartComponent } from './components/custom-basechart/custom-basechart.component';
import { CustomApexchartComponent } from './components/custom-apexchart/custom-apexchart.component';
import { ClickOutSideDirective } from './directives/clickoutside.directive';
import { NgSelectModule } from '@ng-select/ng-select';
import { VisibilityDirective } from './modules/forms-libraries/directives';
import { NgChartsModule } from 'ng2-charts';
import { NgxApexchartsModule } from 'ngx-apexcharts';
import { ModalUploaderClientDialogComponent } from './components/modals/custom-uploader-clients-dialog/custom-uploader-clients-dialog.component';

import { MyFlexLayoutDirective } from './directives/my-flex-layout.directive';
@NgModule({
  imports: [
    RouterModule,
    MaterialModule,
    MatChipsModule,
    FormsModule,
    ReactiveFormsModule,
    ImageCropperModule,
    TranslateModule,
    NgChartsModule.forRoot(),
    NgxApexchartsModule,
    // FlexLayoutModule.withConfig({ addFlexToParent: false }),
    NgSelectModule,
    MyFlexLayoutDirective
  ],
  declarations: [
    LimitToPipe,
    FromNowPipe,
    CapitalizePipe,
    FirstLetterPipe,
    SafePipe,
    TruncatePipe,
    CountDown,
    CountDownInSec,
    EnumPipe,
    LocalDatePipe,
    YesNoPipe,
    SafeHtmlPipe,
    UpdateStatusDialogComponent,
    FetchEntityDialogComponent,
    DeleteEntityDialogComponent,
    ErrorEntityDialogComponent,
    AlertEntityDialogComponent,
    AlertActionEntityDialogComponent,
    ActionNotificationComponent,
    ConfirmSelectEntityDialogComponent,
    ModalPasswordDialogComponent,
    ConfirmInputEntityDialogComponent,
    LoadingScreenComponent,
    ConfirmFileEntityDialogComponent,
    EditProfileDialogComponent,
    LayoutComponent,
    ConfirmDialogComponent,
    ModalUploaderDialogComponent,
    ModalUploaderClientDialogComponent,
    AddGenericNoteDialogComponent,
    RiskLogsDialogComponent,
    ModalViewDialogComponent,
    EnumViewComponent,
    CustomMetadataTableComponent,
    CustomMultipleSelectTreeComponent,
    CustomSelectComponent,
    CustomSelectDialogComponent,
    ClickOutSideDirective,
    CustomSelectAutocompleteComponent,
    ModalDialogComponent,
    CustomMultipleSelectComponent,
    CustomTagsComponent,
    CustomDateTimeComponent,
    RulesViewDialogComponent,
    EvaluationViewDialogComponent,
    VisibilityDirective,
    CustomBasechartComponent,
    CustomApexchartComponent
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatChipsModule,
    TranslateModule,
    LimitToPipe,
    EnumPipe,
    FromNowPipe,
    CapitalizePipe,
    FirstLetterPipe,
    SafePipe,
    TruncatePipe,
    CountDown,
    CountDownInSec,
    LocalDatePipe,
    YesNoPipe,
    SafeHtmlPipe,
    UpdateStatusDialogComponent,
    FetchEntityDialogComponent,
    DeleteEntityDialogComponent,
    ErrorEntityDialogComponent,
    AlertEntityDialogComponent,
    AlertActionEntityDialogComponent,
    ActionNotificationComponent,
    ConfirmSelectEntityDialogComponent,
    ModalPasswordDialogComponent,
    ConfirmInputEntityDialogComponent,
    LoadingScreenComponent,
    ConfirmFileEntityDialogComponent,
    MatRadioModule,
    // FlexLayoutModule,
    ConfirmDialogComponent,
    ModalUploaderDialogComponent,
    ModalUploaderClientDialogComponent,
    AddGenericNoteDialogComponent,
    RiskLogsDialogComponent,
    ModalViewDialogComponent,
    EnumViewComponent,
    CustomMetadataTableComponent,
    CustomMultipleSelectTreeComponent,
    CustomSelectComponent,
    CustomSelectDialogComponent,
    ClickOutSideDirective,
    CustomSelectAutocompleteComponent,
    ModalDialogComponent,
    CustomMultipleSelectComponent,
    CustomTagsComponent,
    CustomDateTimeComponent,
    RulesViewDialogComponent,
    EvaluationViewDialogComponent,
    VisibilityDirective,
    CustomBasechartComponent,
    CustomApexchartComponent,
    MyFlexLayoutDirective
  ]
})
export class SharedModule { }
